import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Fab } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import LinkButton from '../LinkButton';

const ConfirmationDialog = ({
  confirmDialogOpen,
  setConfirmDialogOpen,
  inputKeyword,
  inputMisspellings,
  onSave
}) => (
  <Dialog
    open={confirmDialogOpen}
    onClose={() => setConfirmDialogOpen(false)}
    PaperProps={{
      sx: {
        width: { xs: '90%', sm: 600 },
        p: 2,
      },
    }}
    BackdropProps={{ sx: { backgroundColor: "rgba(128, 128, 128, 1)" }}}
  >
    <DialogTitle sx={{ fontWeight: "bold", fontSize: "1.5rem" }}>
      Please check the following is correct
    </DialogTitle>
    <DialogContent>
      <Typography variant="h6" sx={{ mb: 1 }}>Keyword</Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        {inputKeyword}
      </Typography>
      <Typography variant="h6" sx={{ mb: 1 }}>Misspellings</Typography>
      {inputMisspellings.split(",").map((word, index) => (
        <Typography key={index} variant="body1" sx={{ mb: 0.5 }}>
          {word.trim()}
        </Typography>
      ))}
    </DialogContent>
    <DialogActions>
      <LinkButton
        component={Fab}
        variant="extended"
        onClick={() => setConfirmDialogOpen(false)}
        size="medium"
      >
        <CloseIcon fontSize="small" /> &nbsp;Cancel
      </LinkButton>
      <Fab color="primary" size="medium" variant="extended" onClick={onSave}>
        &nbsp;Confirm
      </Fab>
    </DialogActions>
  </Dialog>
);

export default ConfirmationDialog;
